import { store, getContext, getElement } from '@wordpress/interactivity';
import L from 'leaflet';
import 'leaflet/dist/leaflet.css';
import 'leaflet-gesture-handling/dist/leaflet-gesture-handling.css';
import 'leaflet-gesture-handling';

function getTileLayerUrl(mapStyle) {
    const tileLayers = {
        'light': 'https://{s}.basemaps.cartocdn.com/light_all/{z}/{x}/{y}{r}.png',
        'dark': 'https://{s}.basemaps.cartocdn.com/dark_all/{z}/{x}/{y}{r}.png',
        'satellite': 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        'terrain': 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png',
        'voyager': 'https://{s}.basemaps.cartocdn.com/rastertiles/voyager/{z}/{x}/{y}{r}.png'
    };
    return tileLayers[mapStyle] || tileLayers['light'];
}

function getTileLayerAttribution(mapStyle) {
    const attributions = {
        'light': '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        'dark': '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        'satellite': '&copy; <a href="https://www.esri.com/">Esri</a>',
        'terrain': '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>',
        'voyager': '&copy; <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a> contributors &copy; <a href="https://carto.com/">CARTO</a>'
    };
    return attributions[mapStyle] || attributions['light'];
}

// Fonction pour créer un marqueur SVG moderne (identique à campings-map)
function createModernSVGMarker(color, size = 20, style = 'circle') {
    const baseSize = size * 2;
    // Générer un ID unique pour les filtres SVG
    const uniqueId = 'marker-' + Math.random().toString(36).substr(2, 9);
    
    switch(style) {
        case 'square':
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="${baseSize}" height="${baseSize}" viewBox="0 0 ${baseSize} ${baseSize}">
                    <defs>
                        <filter id="shadow-square-${uniqueId}" x="-20%" y="-20%" width="140%" height="140%">
                            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000" flood-opacity="0.2"/>
                        </filter>
                    </defs>
                    <rect x="${size * 0.5}" y="${size * 0.5}" width="${size}" height="${size}" fill="${color}" stroke="#FFF" stroke-width="2" filter="url(#shadow-square-${uniqueId})"/>
                </svg>
            `;
            
        case 'diamond':
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="${baseSize}" height="${baseSize}" viewBox="0 0 ${baseSize} ${baseSize}">
                    <defs>
                        <filter id="shadow-diamond-${uniqueId}" x="-20%" y="-20%" width="140%" height="140%">
                            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000" flood-opacity="0.2"/>
                        </filter>
                    </defs>
                    <polygon points="${size},${size * 0.3} ${size * 1.7},${size} ${size},${size * 1.7} ${size * 0.3},${size}" fill="${color}" stroke="#FFF" stroke-width="2" filter="url(#shadow-diamond-${uniqueId})"/>
                </svg>
            `;
            
        case 'star':
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="${baseSize}" height="${baseSize}" viewBox="0 0 ${baseSize} ${baseSize}">
                    <defs>
                        <filter id="shadow-star-${uniqueId}" x="-20%" y="-20%" width="140%" height="140%">
                            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000" flood-opacity="0.2"/>
                        </filter>
                    </defs>
                    <polygon points="${size},${size * 0.2} ${size * 1.2},${size * 0.8} ${size * 1.8},${size * 0.8} ${size * 1.3},${size * 1.4} ${size * 1.6},${size * 1.8} ${size},${size * 1.2} ${size * 0.4},${size * 1.8} ${size * 0.7},${size * 1.4} ${size * 0.2},${size * 0.8} ${size * 0.8},${size * 0.8}" fill="${color}" stroke="#FFF" stroke-width="2" filter="url(#shadow-star-${uniqueId})"/>
                </svg>
            `;
            
        case 'pin':
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="${baseSize}" height="${baseSize}" viewBox="0 0 37 48">
                    <defs>
                        <filter id="shadow-pin-${uniqueId}" x="-20%" y="-20%" width="140%" height="140%">
                            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000" flood-opacity="0.2"/>
                        </filter>
                    </defs>
                    <path d="M18.4995 0.2854C8.2968 0.2854 -0.00427246 8.5861 -0.00427246 18.7903C-0.00427246 28.7844 17.2001 45.9947 17.9337 46.7226L18.4996 47.2854L19.067 46.7226C19.7992 45.9947 37.0045 28.7844 37.0045 18.7903C37.0044 8.5861 28.7037 0.2854 18.4995 0.2854ZM18.4995 24.4259C14.0639 24.4259 10.4557 20.8164 10.4557 16.3825C10.4557 11.945 14.0639 8.33482 18.4995 8.33482C22.9365 8.33482 26.5452 11.945 26.5452 16.3825C26.5452 20.8164 22.9365 24.4259 18.4995 24.4259Z" fill="${color}" stroke="#FFF" stroke-width="1" filter="url(#shadow-pin-${uniqueId})"/>
                </svg>
            `;
            
        default: // circle
            return `
                <svg xmlns="http://www.w3.org/2000/svg" width="${baseSize}" height="${baseSize}" viewBox="0 0 ${baseSize} ${baseSize}">
                    <defs>
                        <filter id="shadow-circle-${uniqueId}" x="-20%" y="-20%" width="140%" height="140%">
                            <feDropShadow dx="0" dy="2" stdDeviation="3" flood-color="#000" flood-opacity="0.2"/>
                        </filter>
                    </defs>
                    <circle cx="${size}" cy="${size}" r="${size * 0.5}" fill="${color}" stroke="#FFF" stroke-width="2" filter="url(#shadow-circle-${uniqueId})"/>
                </svg>
            `;
    }
}

const { state, actions } = store('gt/ctv-location', {
    state: {
        map: null,
        marker: null,
        initMap: false
    },
    actions: {
        initMap() {
            if (state.initMap) return;
            
            const element = getElement();
            const context = getContext();
            const { camping, mapStyle, initialZoom, markerStyle, markerColor, mapId } = context;
            
            if (!camping || !camping.latitude || !camping.longitude) {
                console.warn('Camping location: No coordinates available', context);
                return;
            }
            
            // Utiliser la couleur du marqueur ou une couleur par défaut
            const finalMarkerColor = markerColor || '#3498db';
            const finalMarkerStyle = markerStyle || 'circle';
            
            // Utiliser l'ID de la carte depuis le contexte ou chercher l'élément
            const mapContainer = mapId ? document.getElementById(mapId) : element.querySelector('.camping-location-map');
            if (!mapContainer) {
                console.warn('Camping location: Map container not found');
                return;
            }
            
            if (state.map) {
                console.warn('Camping location: Map already initialized');
                return;
            }
            
            // Vérifier que Leaflet est disponible
            if (typeof L === 'undefined') {
                console.error('Camping location: Leaflet is not loaded');
                return;
            }
            
            // Fonction pour initialiser la carte une fois que le conteneur est prêt
            const initializeMap = () => {
                // Initialiser la carte
                const map = L.map(mapContainer, {
                    center: [camping.latitude, camping.longitude],
                    zoom: initialZoom || 13,
                    gestureHandling: true,
                    gestureHandlingOptions: {
                        duration: 200
                    }
                });
                
                // Ajouter la couche de tuiles
                const tileLayer = L.tileLayer(getTileLayerUrl(mapStyle), {
                    attribution: getTileLayerAttribution(mapStyle),
                    maxZoom: 19
                });
                tileLayer.addTo(map);
                
                // Créer l'icône du marqueur
                const customIcon = L.divIcon({
                    html: createModernSVGMarker(finalMarkerColor, 20, finalMarkerStyle),
                    className: 'camping-location-marker',
                    iconSize: [40, 40],
                    iconAnchor: finalMarkerStyle === 'pin' ? [18.5, 48] : [20, 40],
                    popupAnchor: finalMarkerStyle === 'pin' ? [0, -48] : [0, -40]
                });
                
                // Créer le marqueur
                const marker = L.marker([camping.latitude, camping.longitude], { icon: customIcon });
                
                // Construire le contenu de la popup
                let popupContent = '<div class="camping-location-popup">';
                if (camping.name) {
                    popupContent += `<div class="camping-location-popup-name"><strong>${camping.name}</strong></div>`;
                }
                if (camping.address) {
                    popupContent += `<div class="camping-location-popup-address">${camping.address}</div>`;
                }
                popupContent += '</div>';
                
                marker.bindPopup(popupContent);
                marker.addTo(map);
                
                // Ouvrir la popup par défaut
                marker.openPopup();
                
                // Ajuster la vue pour centrer le marqueur
                map.setView([camping.latitude, camping.longitude], initialZoom || 13);
                
                // Forcer un invalidateSize pour s'assurer que la carte s'affiche correctement
                setTimeout(() => {
                    map.invalidateSize();
                }, 100);
                
                // Stocker dans le state
                state.map = map;
                state.marker = marker;
                state.initMap = true;
            };
            
            // Attendre que le conteneur soit visible et ait une taille
            const checkContainer = () => {
                if (mapContainer.offsetWidth === 0 || mapContainer.offsetHeight === 0) {
                    setTimeout(checkContainer, 100);
                    return;
                }
                initializeMap();
            };
            
            // Démarrer la vérification
            if (document.readyState === 'loading') {
                document.addEventListener('DOMContentLoaded', checkContainer);
            } else {
                // Utiliser requestAnimationFrame pour s'assurer que le DOM est prêt
                requestAnimationFrame(() => {
                    setTimeout(checkContainer, 50);
                });
            }
        }
    }
});
